import { ReactNode } from 'react';
import { Modal as BootstrapModal } from 'react-bootstrap';
import { i18n, type MessageKey } from 'shared/i18n';

interface ModalProps {
  titleLabelKey?: MessageKey;
  children?: ReactNode;
  show: boolean;
  onClose?: () => void;
  size?: 'sm' | 'lg' | 'xl';
  scrollable?: boolean;
  centered?: boolean;
  footer?: ReactNode;
  dialogClassName?: string;
  headerActions?: ReactNode;
}

const Modal = ({ titleLabelKey, children = null, show, onClose, size, scrollable, centered, footer, dialogClassName, headerActions }: ModalProps) => {
  return (
    <BootstrapModal show={show} onHide={onClose} size={size} scrollable={scrollable} centered={centered} dialogClassName={dialogClassName}>
      {titleLabelKey ? (
        <BootstrapModal.Header className={titleLabelKey ? 'bg-blue-200' : 'bg-white'}>
          <h3 className="modal-title">{i18n(titleLabelKey)}</h3>
          {headerActions}
          <button
            onClick={(e) => {
              e.persist();
              onClose?.();
            }}
            type="button"
            className="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          />
        </BootstrapModal.Header>
      ) : null}
      <BootstrapModal.Body>{children}</BootstrapModal.Body>
      {footer ? <BootstrapModal.Footer>{footer}</BootstrapModal.Footer> : null}
    </BootstrapModal>
  );
};

export default Modal;
